import { localizationReducerPath, localizationSlice } from '@cp/shared/localization';
import { authenticationReducerPath, authenticationSlice, coreApi } from '@cp/shared/api/core';
import { modalViewReducerConfig } from '@cp/ds/src/components/modalView';
import { dialogReducerConfig } from '@cp/entities/dialog';
import { introReducerPath, introSlice } from '@cp/entities/intro';
import { metaReducerPath, metaSlice } from '@cp/shared/meta';
import { clientFavoritesReducerConfig } from '@cp/entities/client/current/favorite';
import { mainResumeReducerConfig } from 'src/entities/mainResume';
import { clientRegistrationReducerConfig } from 'src/features/registration';
import { clientTrainingReducerConfig } from 'src/features/client/training';
import { locationCitySelectionReducerConfig } from 'src/features/location';
import { catalogReducerConfig } from 'src/features/catalog';
import { embeddingReducerPath, embeddingSlice } from 'src/shared/embedding';
import { burgerMenuReducerPath, burgerMenuSlice } from 'src/features/burgerMenu';
import { modalQueueReducerConfig } from 'src/shared/modalProvider';
import { catalogItemViewReducerConfig } from 'src/features/catalogItem/view';
import { UXSlice, uxReducerPath } from 'src/shared/ux';
import { catalogItemConfig } from 'src/entities/catalog';
import { reducerConfig as themeReducerConfig } from './../../app/providers/theme';

export const reducerConfig = {
  ...clientTrainingReducerConfig,
  ...clientRegistrationReducerConfig,
  ...dialogReducerConfig,
  ...clientFavoritesReducerConfig,
  ...mainResumeReducerConfig,
  ...modalViewReducerConfig,
  ...locationCitySelectionReducerConfig,
  ...catalogReducerConfig,
  ...catalogItemViewReducerConfig,
  ...themeReducerConfig,
  ...modalQueueReducerConfig,
  ...catalogItemConfig,
  [authenticationReducerPath]: authenticationSlice.reducer,
  [localizationReducerPath]: localizationSlice.reducer,
  [introReducerPath]: introSlice.reducer,
  [metaReducerPath]: metaSlice.reducer,
  [uxReducerPath]: UXSlice.reducer,
  [embeddingReducerPath]: embeddingSlice.reducer,
  [burgerMenuReducerPath]: burgerMenuSlice.reducer,
  [coreApi.reducerPath]: coreApi.reducer,
} as const;
